/**
 * "Planlama" ve "İşleyiş" blokları (28.10.2026): satışçı hazır metin şablonu ekler ya da kendi metnini yazar. Metin satır satırdır;
 * PDF'te kendi başlığıyla ayrı blok olur ("Bilmeniz gerekenler" listesine karışmaz), mesaj taslağına girmez.
 * Şablon seçilince mevcut metne eklenir ve düzenlenebilir; aynı şablon ikinci kez eklenmez.
 */
import { useId } from 'react';
import { HIZLI_METIN as M } from '../metin/hizliTeklif';
import { GRUP_BASLIGI, STANDART_SABLONLAR, sablonEkle, type SablonGrubu } from './sablonlar';

export const PLAN_METNI_AZAMI = 1200;

function Blok({ grup, metin, devreDisi, degisti }: { grup: SablonGrubu; metin: string; devreDisi: boolean; degisti: (m: string) => void }) {
  const kimlik = useId();
  const sablonlar = STANDART_SABLONLAR.filter((s) => s.grup === grup);
  const id = grup === 'PLANLAMA' ? 'planlama' : 'isleyis';
  return (
    <div className="ht-plan-blok" data-testid={`ht-${id}-blok`}>
      <div className="ht-plan-blok-ust">
        <label htmlFor={`${kimlik}-metin`} className="ht-etiket">{GRUP_BASLIGI[grup]}</label>
        <select
          aria-label={`${GRUP_BASLIGI[grup]}: ${M.plan.sablonSec}`}
          value=""
          disabled={devreDisi}
          data-testid={`ht-${id}-sablon`}
          onChange={(e) => { const s = sablonlar.find((x) => x.kimlik === e.target.value); if (s !== undefined) degisti(sablonEkle(metin, s, PLAN_METNI_AZAMI)); }}
        >
          <option value="">{M.plan.sablonSecYok}</option>
          {sablonlar.map((s) => <option key={s.kimlik} value={s.kimlik}>{s.baslik}</option>)}
        </select>
      </div>
      <textarea id={`${kimlik}-metin`} rows={5} maxLength={PLAN_METNI_AZAMI} value={metin} disabled={devreDisi} data-testid={`ht-${id}-metin`} onChange={(e) => degisti(e.target.value)} />
      <span className="ht-ipucu">{M.plan.sayac(metin.length, PLAN_METNI_AZAMI)}</span>
    </div>
  );
}

export function PlanAlani({ planlama, isleyis, devreDisi, planlamaDegisti, isleyisDegisti }: { planlama: string; isleyis: string; devreDisi: boolean; planlamaDegisti: (m: string) => void; isleyisDegisti: (m: string) => void }) {
  const kimlik = useId();
  return (
    <section className="ht-kart" aria-labelledby={`${kimlik}-baslik`} data-testid="ht-plan-kart">
      <div className="ht-kart-ust"><h2 id={`${kimlik}-baslik`}>{M.plan.baslik}</h2></div>
      <p className="ht-ipucu">{M.plan.ipucu}</p>
      <div className="ht-plan-bloklar">
        <Blok grup="PLANLAMA" metin={planlama} devreDisi={devreDisi} degisti={planlamaDegisti} />
        <Blok grup="ISLEYIS" metin={isleyis} devreDisi={devreDisi} degisti={isleyisDegisti} />
      </div>
    </section>
  );
}
